<template>
  <div class="order" @click="updateOrder('select')" :class="{'order--active' : isActiveOrder}">
    <div class="order__radio"></div>
    <div class="order__client">{{orderItem.client.name}}</div>
    <div
      class="order__location"
    >{{orderItem.client.address.line1}}, {{orderItem.client.address.zipCode}}, {{orderItem.client.address.city}}, {{orderItem.client.address.country}}</div>
    <div class="order__quantity">{{quantity}}</div>
    <div class="order__price">{{price | price}}</div>
    <div class="order__date">
      {{resource('startDateOrder')}}
      <br>
      {{orderItem.added | date}}
    </div>
    <button class="button--no order__delete-button" @click.stop="deletePrompt = true">
      <icon class="button__icon" name="trash"/>
    </button>
    <div class="order__prompt" v-if="deletePrompt" @click.stop>
      <div class="prompt__text">{{resource('sureDelete')}}</div>
      <button class="button button--secondary-light" @click="updateOrder('delete')">{{resource('yes')}}</button>
      <button class="button button--cancel button--outline" @click="deletePrompt = false">{{resource('cancel')}}</button>
    </div>
  </div>
</template>

<style lang="scss">
.order {
  display: grid;
  grid-template-columns: 70px 4fr 2fr 3fr 70px;
  grid-template-rows: 1fr 1fr;
  padding: $content;
  position: relative;
  + .order {
    border-top: 1px solid $order__border;
  }
  &__radio {
    grid-area: 1/1/3/2;
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;
    align-self: center;
    justify-self: center;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__client {
    grid-area: 1/2/2/3;
    font-weight: bold;
  }
  &__location {
    grid-area: 2/2/3/3;
  }
  &__quantity {
    grid-area: 1/3/2/4;
  }
  &__price {
    grid-area: 2/3/3/4;
  }
  &__date {
    grid-area: 1/4/3/5;
    align-self: center;
  }
  &__delete-button {
    grid-area: 1/5/3/6;
  }
  &__prompt {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $prompt__bg;
    color: $prompt__color;
    display: flex;
    justify-content: center;
    align-items: center;
    > * + * {
      margin-left: $content;
      font-weight: bold;
    }
    .button{
      height:40px;
      padding: 20px;
    }
  }
  &--active &__radio:after {
    width: 60%;
    height: 60%;
    border-radius: 100%;
    background: $secondary;
    content: "";
    display: block;
  }
}
</style>

<script>
export default {
	name: 'orderItem',
	props: {
		order: Object
	},
	computed: {
		isActiveOrder() {
			if (this.$store.getters.order.id === this.order.id) {
				return true
			} else {
				return false
			}
		},
		orderItem() {
			return this.$store.getters.orderById(this.order.id)
		},
		quantity() {
			var cartAmount = 0
			for (let i = 0; i < this.orderItem.cart.length; i++) {
				const item = this.orderItem.cart[i]
				cartAmount += item.amount
			}
			if (cartAmount === 1) {
				return `${cartAmount} ${this.resource('product')}`
			} else {
				return `${cartAmount} ${this.resource('products')}`
			}
		},
		price() {
			var cart = this.orderItem.cart
			var amount = 0
			for (let i = 0; i < cart.length; i++) {
				const product = cart[i]
				amount += product.price.amount * product.amount
			}
			return {
				amount: amount,
				currency: 'EUR'
			}
		}
	},
	data() {
		return {
			deletePrompt: false,
			res: {
				nl: {
					product: 'artikel',
					products: 'artikelen',
					delete: 'Verwijder',
					yes: 'Ja',
					cancel: 'Annuleer',
					sureDelete: 'Weet u zeker dat u deze order wilt verwijderen?',
					startDateOrder: 'Order gestart op:'
				},
				fr: {
					product: 'article',
					products: 'articles',
					delete: 'Enlever',
					yes: 'Oui',
					cancel: 'Annuler',
					sureDelete: 'Êtes-vous sûr de vouloir supprimer cette commande?',
					startDateOrder: 'Commande commencée le:'
				}
			}
		}
	},
	methods: {
		resource(item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		updateOrder(msg) {
			this.deletePrompt = false
			this.$emit('update', msg)
		}
	}
}
</script>
